import type { SVGProps } from 'react';

export const SvgIconArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 6L8 11L3 6" strokeWidth="1.5" strokeLinejoin="round" stroke="currentColor"></path>
  </svg>
);
